"use strict";

exports.__esModule = true;
exports.WHITE_SPACE = exports.VALID_KEY = exports.VALID_QUOTES = exports.QUOTED_KEY = exports.NUMBER = exports.MAX_CACHE_SIZE = exports.DOTTY_WITH_BRACKETS_SYNTAX = exports.CACHE = void 0;

/**
 * @constant {Object} CACHE
 *
 * @property {function} clear clear the cache results
 * @property {Object} results the map of path => array results
 * @property {number} size the size of the cache
 */
var CACHE = {
  clear: function clear() {
    CACHE.results = {};
    CACHE.size = 0;
  },
  results: {},
  size: 0
};
/**
 * @constant {RegExp} DOTTY_WITH_BRACKETS_SYNTAX
 */

exports.CACHE = CACHE;
var DOTTY_WITH_BRACKETS_SYNTAX = /"[^"]+"|`[^`]+`|'[^']+'|[^.[\]]+/g;
/**
 * @constant {number} MAX_CACHE_SIZE
 */

exports.DOTTY_WITH_BRACKETS_SYNTAX = DOTTY_WITH_BRACKETS_SYNTAX;
var MAX_CACHE_SIZE = 500;
/**
 * @constant {RegExp} NUMBER
 */

exports.MAX_CACHE_SIZE = MAX_CACHE_SIZE;
var NUMBER = /^\d+$/i;
/**
 * @constant {RegExp} QUOTED_KEY
 */

exports.NUMBER = NUMBER;
var QUOTED_KEY = /^"[^"]+"|`[^`]+`|'[^']+'$/;
/**
 * @constant {Array<string>} VALID_QUOTES
 */

exports.QUOTED_KEY = QUOTED_KEY;
var VALID_QUOTES = /^["'`]{1}$/;
/**
 * @constant {RegExp} VALID_KEY
 */

exports.VALID_QUOTES = VALID_QUOTES;
var VALID_KEY = /^\d+$|^[a-zA-Z_$][\w$]+$/;
/**
 * @constant {RegExp} WHITE_SPACE
 */

exports.VALID_KEY = VALID_KEY;
var WHITE_SPACE = /\s/;
exports.WHITE_SPACE = WHITE_SPACE;